module.exports = __webpack_public_path__ + "img/200.d93d9b8f.jpg";